function MessageIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15.8 6H6.2C5.54 6 5 6.495 5 7.1V17l2.4-2.2h8.4c.66 0 1.2-.495 1.2-1.1V7.1c0-.605-.54-1.1-1.2-1.1z" />
    </svg>
  )
}

export default MessageIcon
